import { defineStore } from "pinia"

export const SettingsState = defineStore("SettingsState", {
  state: () => ({
    expandedRows: [] 
  }),
  actions: {
    toggleKey(key) {
      const i = this.expandedRows.indexOf(key)
      if (i === -1) this.expandedRows.push(key)
      else this.expandedRows.splice(i, 1)
    },
    clearList() {
        this.expandedRows = []
    }
  }
});